var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#D2D2D2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8643 15.0834H20.1351C16.3434 15.0834 14.083 17.3438 14.083 21.1355V29.8542C14.083 33.6563 16.3434 35.9167 20.1351 35.9167H28.8538C32.6455 35.9167 34.9059 33.6563 34.9059 29.8646V21.1355C34.9163 17.3438 32.6559 15.0834 28.8643 15.0834ZM24.4997 29.5417C22.2705 29.5417 20.458 27.7292 20.458 25.5C20.458 23.2709 22.2705 21.4584 24.4997 21.4584C26.7288 21.4584 28.5413 23.2709 28.5413 25.5C28.5413 27.7292 26.7288 29.5417 24.4997 29.5417ZM30.6663 20.1667C30.6143 20.2917 30.5413 20.4063 30.4476 20.5105C30.3434 20.6042 30.2288 20.6771 30.1038 20.7292C29.9143 20.8097 29.705 20.8318 29.5028 20.7929C29.3006 20.7539 29.1145 20.6556 28.9684 20.5105C28.8747 20.4063 28.8018 20.2917 28.7497 20.1667C28.6962 20.0415 28.6679 19.907 28.6663 19.7709C28.6663 19.6355 28.6976 19.5 28.7497 19.375C28.8018 19.2396 28.8747 19.1355 28.9684 19.0313C29.208 18.7917 29.5726 18.6771 29.9059 18.75C29.9788 18.7605 30.0413 18.7813 30.1038 18.8125C30.1663 18.8334 30.2288 18.8646 30.2913 18.9063C30.3434 18.9375 30.3955 18.9896 30.4476 19.0313C30.5413 19.1355 30.6143 19.2396 30.6663 19.375C30.7184 19.5 30.7497 19.6355 30.7497 19.7709C30.7497 19.9063 30.7184 20.0417 30.6663 20.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4fb3d9e35a36165601aec9106573a14c.svg";
export { ForwardRef as ReactComponent };